import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import axios from "axios";
import VueAxios from "vue-axios";

axios.defaults.baseURL = "https://www.berlinave.com/BERLINUXERP/";

import PrimeVue from "primevue/config";

import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import FloatLabel from 'primevue/floatlabel';
import AutoComplete from 'primevue/autocomplete';
import Textarea from 'primevue/textarea';
import ProgressBar from 'primevue/progressbar';
import Message from 'primevue/message';
import Skeleton from 'primevue/skeleton';
//import DataTable from 'primevue/datatable';
//import Column from 'primevue/column';
import RadioButton from 'primevue/radiobutton';
import Checkbox from 'primevue/checkbox';
import Calendar from 'primevue/calendar';
import Dialog from 'primevue/dialog';
import ProgressSpinner from 'primevue/progressspinner';
import Dropdown from 'primevue/dropdown';
import Image from 'primevue/image';
import Card from 'primevue/card';
import InputSwitch  from 'primevue/inputswitch';
import Timeline from 'primevue/timeline';
import Badge from 'primevue/badge';
import Accordion from "primevue/accordion";
import AccordionTab from 'primevue/accordiontab';

import NavbarMain from "@/components/NavbarMain.vue";
import FooterComp from "@/components/FooterComp.vue";
import SliderComp from '@/components/SliderComp.vue';
import Noticias from "@/components/NoticiasComp.vue";

import "primevue/resources/themes/saga-green/theme.css"; //theme
import "primevue/resources/primevue.min.css"; //core css
import "primeicons/primeicons.css"; //icons
import 'primeflex/primeflex.css';

import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const app = createApp(App);

import util from './util/util';

app.config.globalProperties.$utilidad = util;

app.component("ButtonPrime", Button);
app.component("InputText", InputText);
app.component("FloatLabel", FloatLabel);
app.component("AutoComplete", AutoComplete);

app.component("TextArea", Textarea);
app.component("SkeletonPrime", Skeleton);
app.component("InlineMessage", Message);
// app.component("CarouselPrime", DataTable);
// app.component("Column", Column);
app.component("ProgressBar", ProgressBar);
app.component("RadioButton", RadioButton);
app.component("CheckboxPrime", Checkbox);
app.component("CalendarPrime", Calendar);
app.component("DialogPrime", Dialog);
app.component("ProgressSpinner", ProgressSpinner);
app.component("DropDown", Dropdown);
app.component("ImagePrime", Image);
app.component("CardPrime", Card);
app.component("InputSwitch", InputSwitch);
app.component("TimeLine", Timeline);
app.component("BadgePrime", Badge);
app.component("AccordionMain", Accordion);
app.component("AccordionTab", AccordionTab);

app.component("NavbarMain", NavbarMain);
app.component("FooterComp", FooterComp);
app.component("SliderComp", SliderComp);
app.component("NoticiasComp", Noticias);


app.use(router);
app.use(VueAxios, axios);

// const options = {
//   confirmButtonColor: "#004d27",
//   cancelButtonColor: "#E71310",
// };


app.use(PrimeVue, {
  locale: {
    accept: "Si",
    reject: "No",
    choose: "Elegir",
    upload: "Subir",
    cancel: "Cancelar",
    dayNames: [
      "Domingo",
      "Lunes",
      "Martes",
      "Miercoles",
      "Jueves",
      "Viernes",
      "Sabado",
    ],
    dayNamesShort: ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"],
    dayNamesMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
    monthNames: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],
    monthNamesShort: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic",
    ],
    today: "Today",
    weekHeader: "Wk",
    firstDayOfWeek: 0,
    dateFormat: "mm/dd/yy",

    // ... más configuraciones
  },
});

app.mount("#app");
